/** Persist list query so info "List" returns with filters. */
export const PLATE_PRODUCTION_LIST_SEARCH_KEY = "plate-production-list-search";

export const getPlateProductionListPath = () => {
  const q = sessionStorage.getItem(PLATE_PRODUCTION_LIST_SEARCH_KEY) || "";
  return `/plate-production${q}`;
};

export const getPlateProductionRowId = (record) =>
  record?.ProductionNo ?? record?.production_no ?? record?.id;
